import { Box, Button, Modal, Typography, useTheme } from '@mui/material';
import { strings } from 'i18n/Strings';
import { colorTheme } from 'theme';

interface ILogoutModalProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const ConfirmationModal = ({
  open,
  onClose,
  onContinue,
}: ILogoutModalProps): JSX.Element => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);
  return (
    <Modal open={open}>
      <Box
        sx={{
          position: 'absolute' as const,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',

          bgcolor: 'background.paper',
          boxShadow: 24,
          py: 5,
          px: 5,
          borderRadius: 5,
        }}
      >
        <Typography variant="h5" component="h2" sx={{ textAlign: 'center' }}>
          {strings.displayText.leavingThisPageText}
        </Typography>
        <Typography
          variant="h5"
          component="h2"
          sx={{ textAlign: 'center', marginTop: 2 }}
        >
          {strings.displayText.areYouSureYouWantToLeaveText}
        </Typography>
        <Box
          sx={{
            pt: 3,
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              mt: 3,
              mb: 2,
              bgcolor: 'white',
              borderRadius: 2,
              py: 1.5,
              '&:hover': {
                bgcolor: colors.gray[800],
              },
            }}
          >
            <Typography
              component="h1"
              variant="h5"
              style={{ fontSize: '12px', color: colors.primaryBg[700] }}
            >
              {strings.displayText.cancel}
            </Typography>
          </Button>
          <Button
            onClick={onContinue}
            variant="contained"
            sx={{
              mt: 3,
              mb: 2,
              bgcolor: colors.greenAccent[500],
              borderRadius: 2,
              py: 1.5,
            }}
          >
            <Typography
              component="h1"
              variant="h5"
              style={{ fontSize: '12px' }}
            >
              {strings.displayText.continueText}
            </Typography>
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
